import { useAdminTickets, TICKETS_PER_PAGE } from "@/hooks/useAdminTickets";
import TicketsFilter from "./tickets/TicketsFilter";
import TicketsTable from "./tickets/TicketsTable";
import TicketStatsCard from "./tickets/TicketStatsCard";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ChevronLeft, ChevronRight, Ticket } from "lucide-react";

const TicketsList = () => {
  const {
    tickets,
    isLoading,
    isEmpty,
    // Tag-based filters
    filterTags,
    addFilter,
    removeFilter,
    clearAllFilters,
    // Actions
    deleteTicket,
    refundTicket,
    refundingTicketId,
    // Pagination
    currentPage,
    setCurrentPage,
    totalPages,
    totalTickets,
    // Sorting
    sortField,
    sortDirection,
    handleSort,
  } = useAdminTickets();

  return (
    <div className="space-y-6">
      {/* Stats Overview Card with Charts */}
      <TicketStatsCard />

      {/* Tickets Table Card */}
      <Card>
        <CardHeader className="pb-3">
          <div className="flex items-center justify-between gap-4">
            <div>
              <CardTitle className="flex items-center gap-2">
                <Ticket className="h-5 w-5 text-secondary" />
                Tickets Management
              </CardTitle>
              <CardDescription>
                View and manage event ticket bookings
              </CardDescription>
            </div>
            <TicketsFilter
              filterTags={filterTags}
              onAddFilter={addFilter}
              onRemoveFilter={removeFilter}
              onClearAllFilters={clearAllFilters}
            />
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          
          <div className="rounded-md border overflow-x-auto">
            <TicketsTable
              tickets={tickets}
              isLoading={isLoading}
              isEmpty={isEmpty}
              searchQuery=""
              deleteTicket={deleteTicket}
              refundTicket={refundTicket}
              refundingTicketId={refundingTicketId}
              sortField={sortField}
              sortDirection={sortDirection}
              onSort={handleSort}
            />
          </div>
          
          {totalTickets > 0 && (
            <div className="flex items-center justify-between mt-3">
              <p className="text-sm text-muted-foreground">
                {totalPages > 1 
                  ? `Showing ${(currentPage - 1) * TICKETS_PER_PAGE + 1} to ${Math.min(currentPage * TICKETS_PER_PAGE, totalTickets)} of ${totalTickets} tickets`
                  : `Showing ${totalTickets} tickets of ${totalTickets}`
                }
              </p>
              {totalPages > 1 && (
                <div className="flex items-center gap-2">
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setCurrentPage((prev) => Math.max(1, prev - 1))}
                    disabled={currentPage === 1}
                  >
                    <ChevronLeft className="h-4 w-4" />
                    Previous
                  </Button>
                  <span className="text-sm text-muted-foreground">
                    Page {currentPage} of {totalPages}
                  </span>
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={() => setCurrentPage((prev) => Math.min(totalPages, prev + 1))}
                    disabled={currentPage === totalPages}
                  >
                    Next
                    <ChevronRight className="h-4 w-4" />
                  </Button>
                </div>
              )}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default TicketsList;